export const objectsEqual = (o1, o2) =>
  typeof o1 === 'object'
    ? Object.keys(o1).length === Object.keys(o2).length &&
      Object.keys(o1).every((p) => objectsEqual(o1[p], o2[p]))
    : o1 === o2;

export const arraysEqual = (a1, a2) =>
  a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));

export const deepClone = (data) => JSON.parse(JSON.stringify(data));

export const matchesSchema = (schema) => (value) => {
  return Object.entries(schema).every(([key, type]) => {
    return key in value && typeof value[key] === type;
  });
};
